<template>
  <!-- 通用饼状图统计，空心圆环 -->
  <div class="worker-count">
    <div :id="id" class="echarts"></div>
  </div>
</template>

<script>

import {useRoute, useRouter} from "vue-router";
import * as echarts from "echarts";
import {watch} from "vue";

export default {
  props: {
    colorList: {
      default: () => ["#38d7ff","#ff7621","#ffc421","#fdea43","#9eff17","#38ff6d","#4599ff","#9e66ff","#f94aff"]
    },
    dataList: {
      default: () => [
        { value: 1048, name: '水电工' },
        { value: 735, name: '运输' },
        { value: 580, name: '仓管' },
        { value: 484, name: '保安' },
        { value: 300, name: '保洁' }
      ]
    }
  },
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "SimplePieCircle",
  components: {
  },
  data() {
    return {
      id: "echarts",
      workerCountResult: {
        workerCount: 0,
        workerSum: [
        ]
      },
      echartsCircle: null,
    };
  },
  mounted() {
    this.$nextTick().then(() => {
      console.log("显示数据")
      this.loadEcharts();
    });
  },
  created() {
    // 生成一个随机id
    this.id = "echarts" + Math.random().toString(36).substr(2);
    watch(() => this.dataList, () => {
      console.log("数据变更")
      this.loadEcharts();
    })
  },
  methods: {
    initEcharts() {
      if (this.echartsCircle) {
        let datas = this.dataList;
        let option = {
          tooltip: {
            trigger: 'item'
          },
          grid: {
            top: 0,
          },
          legend: {
            show: false,
            bottom: '0',
            left: 'center',
            formatter: (name) => {
              for (let i = 0; i < datas.length; i++) {
                if (name === datas[i].name) {
                  return `${name} ${datas[i].value}`;
                }
              }
            },
          },
          series: [
            {
              name: '劳务人员统计',
              type: 'pie',
              radius: ['50%', '70%'],
              avoidLabelOverlap: false,
              label: {
                show: false,
                position: 'center'
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: 30,
                  fontWeight: 'bold'
                }
              },
              labelLine: {
                show: false
              },
              data: this.dataList,
              itemStyle: {
                normal: {
                  color: (params) => {
                    return this.colorList[params.dataIndex % this.colorList.length];
                  }
                }
              }
            }
          ]
        };

        // 使用刚指定的配置项和数据显示图表。
        this.echartsCircle.setOption(option);
      }
    },
    loadEcharts() {
      if (this.echartsCircle) {
        // 重新初始化
        this.echartsCircle.dispose();
      }
      this.echartsCircle = echarts.init(document.getElementById(this.id));
      this.initEcharts();
    },
  }
};
</script>

<style lang="scss" scoped>
.echarts{
  width: 100%;
  height: 100%;
}
.worker-count{
  margin-bottom: 20px;
  height: 100%;
  .echarts-label{
    font-size: 12px;
    .echarts-label-item{
      display: inline-flex;
      width: 33.333%;
      .echarts-label-item-color{
        width: 5px;
        margin-right: 5px;
      }
      .echarts-label-item-name{
        width: 46px;
      }
      .echarts-label-item-value{
        color: var(--map-color-text);
      }
    }
  }
}
</style>